<template>
  <section id="dhruAPI">
    <!-- All info -->
    <div class="info-display">
      <div
        class="info-box"
        v-for="([key, inform], i) in Object.entries(info)"
        :key="`in${key}-${i}`"
        v-if="inform.value"
      >
        <h5 class="mr-1 mb-1">{{ inform.label }}</h5>
        <CopyText :text="inform.value" />
      </div>
    </div>

    <div class="dhru-doc">
      <h1><center>INFO</center></h1>

      <h3 class="mt-2">
        The script is fully compatible with DHRU BULK API (v6.1)
      </h3>
      <br />
      <p>
        <strong>
          We recommend that you enable DHRU BULK API SEND + GET in your script
          to improve performance and response time.
        </strong>
        <br /><br />
        → Set the "Send Order Per Batch" limit to <strong>120</strong> to avoid
        duplicate orders.<br />
      </p>
      <p>
        → If you use a cronjob in seconds, set the "Send Order Per Batch" number
        equal to the number of seconds at which you run the cronjob.
      </p>

      <hr class="my-4" />

      <h4 class="mt-3">
        Why IMEICheck.com Was Blacklisted by DHRU Fusion
      </h4>

      <p>
        We discovered that DHRU encoded their software with hidden expiration
        dates using Ioncube, even for users with lifetime licenses. When the
        software stopped working due to this expiration, we were asked to pay
        for support — despite having already purchased a license with no such
        limitations.
      </p>

      <ul>
        <li>
          <strong>Lifetime license is a trap:</strong> DHRU advertises a
          "lifetime license," but in reality, the core files are secretly set to
          expire using Ioncube. When those files expire, the system becomes
          unusable.
        </li>
        <li>
          <strong>No help without more payment:</strong> When your system breaks
          due to this forced expiration, DHRU refuses to assist unless you pay
          again for a full support package — even if you already paid for a
          valid license.
        </li>
        <li>
          <strong>They create the problem, then sell the fix:</strong> This
          model is intentionally designed to lock customers in, break their
          systems, and force them to pay just to regain functionality — even
          though the issue was caused by DHRU’s hidden limitations.
        </li>
      </ul>

      <p>
        After we published our findings to help inform and protect others in the
        community, DHRU retaliated by blacklisting our domain
        (<strong>imeicheck.com</strong>) across their entire ecosystem. This
        decision was not based on fraud or abuse — it was a direct punishment
        for exposing the truth.
      </p>

      <p>
        <strong>We strongly encourage others to read our full report</strong>
        and understand the risks of relying on vendor-controlled software
        without full access to the source code or fair licensing terms:
        <a href="https://imeicheck.com/dhru-fusion-scam" target="_blank"
          >Read the full report</a
        >.
      </p>
    </div>
  </section>
</template>

<script>
import CopyText from "@/components/util/CopyText.vue";
import { mapState } from "vuex";

export default {
  components: { CopyText },
  data: () => ({
    info: {
      apiKey: { label: "Your Access key", value: "" },
      username: { label: "Username", value: "" },
      url: { label: "URL", value: "https://dhru.checkimei.com" },
    },
  }),
  computed: {
    ...mapState({ getUser: "user" }),
    user() {
      return this.getUser.user || {};
    },
  },
  watch: {
    user: {
      handler() {
        this.updateUser();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    updateUser() {
      if (!this.user) return;
      this.info.apiKey.value = this.user.api_key || "";
      this.info.username.value = this.user.username || "";
    },
  },
};
</script>

<style lang="scss" scoped>
#dhruAPI {
  display: flex;
  gap: 20px;

  @media (max-width: 740px) {
    flex-direction: column;
  }
}

.info-display {
  flex: 0.4;
  padding: 20px;
  box-shadow: 1px 1px 20px rgba(23, 29, 49, 0.66);
  border-radius: 20px;

  @media (max-width: 740px) {
    margin-right: 0;
  }
}

.info-box {
  margin-bottom: 20px;
}

.dhru-doc {
  flex: 0.6;
}
</style>
